import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  fcmToken = new BehaviorSubject(null);

  constructor(
    private angularFireMessaging: AngularFireMessaging) {
  }
  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        this.fcmToken.next(token);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }
  receiveMessage() {
    this.angularFireMessaging.messaging.subscribe(
      (messageObj) => {
        messageObj.onMessage(newMessage => this.currentMessage.next(newMessage));
      },
      err => console.error(err));
  }

  removeToken() {
    this.angularFireMessaging.deleteToken(localStorage.getItem('fcmToken')).subscribe(
      _data => console.log('Token Cleaned'), err => console.error(err));
  }
}